import React from "react";
import BackButton from "./Backbutton";
import { useState, useEffect } from "react";

const Title = ({
  title,
  imageUrl,
  bottomImageUrl,
  textColor = "text-white",
  pb = "pb-2",
  style = {},
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 700 && window.innerWidth <= 1200
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
      setIsTablet(window.innerWidth >= 700 && window.innerWidth <= 1200);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="relative p-2 flex flex-col justify-center items-center">
      <div
        className="pb-0 p-0 mb-0 m-0 bdradius"
        style={{
          position: "absolute",
          top: "15%",
          left: "0",
          zIndex: "",
          overflow: "hidden",
        }}
      >
        <BackButton className="pb-0 p-0 mb-0 m-0 ">
          <svg
            className={`arrowsvg  ${isMobile ? "p-1" : ""}`}
            style={{
              height: isTablet ? "5vh" : "5.2vh",
              width: "100%",
              borderRadius: "50%",
              zIndex: 999999,
              overflow: "hidden",
              padding: "0",
              margin: 0,
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="2 2 20 20"
          >
            <style type="text/css">{`.st0{fill:#010101;}`}</style>
            <path
              className="st0"
              d="M12,1.2C6,1.2,1.2,6,1.2,12C1.2,18,6,22.8,12,22.8S22.8,18,22.8,12C22.8,6,18,1.2,12,1.2z M19.1,12.6
    c-0.2,0.2-0.4,0.3-0.6,0.3H8.6l4.3,4.3c0.2,0.2,0.3,0.4,0.2,0.6c0,0.2-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.2-0.6,0.2
    c-0.2,0-0.4-0.1-0.6-0.2l-5.8-5.8c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
    l5.8-5.8c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6l-4.3,4.3h9.8
    c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6S19.2,12.5,19.1,12.6z"
            />
          </svg>
        </BackButton>
      </div>
      <div className="flex  justify-center items-center ">
        <div className=" px-0">
          <div
            className={`  style-script-regular   p-0  ${textColor} `}
            style={{ height: isTablet ? "3rem" : "",fontFamily: 'Baby Givoni' }}
          >
            <p
              className={`pb-0 mb-0  `}
              style={{ fontSize: isTablet ? "5vh" : "5.5vh", ...style }}
            >
              {title}
            </p>
          </div>
        </div>
      </div>

      <div className={`  pt-2    ${pb} `}>
        <img
          src="/img/ic_weddingline.svg"
          alt="Bottom Image"
          style={{ height: "3.1vh" }}
          className=" object-cover mobileversion mobileline"
        />
      </div>
    </div>
  );
};

export default Title;
